import { render, staticRenderFns } from "./platformTab.vue?vue&type=template&id=d27ac92e&"
import script from "./platformTab.vue?vue&type=script&lang=js&"
export * from "./platformTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports